import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/company-profile/import-hub')({
  async beforeLoad({ location }) {
    const newPath = location.pathname.replace(
      '/company-profile/import-hub',
      '/external-data/import-hub',
    );
    throw redirect({
      to: newPath,
      search: location.search,
    });
  },
});
